export const smashuItems = [
  {
    name: "Structural Vascular Lesions (S)",
    description: "Structural Vascular Lesions - including cavernomas and arterovenous malformations",
    value: "S",
    interpretation: ""
  },
  {
    name: "Medications (M)",
    description: "Warfarin with INR >= 2.0, novel oral anticoagulants within 3 days, full-dose heparin, or non-IS systemic thrombolysis.",
    value: "M",
    interpretation: ""
  },
  {
    name: "Amyloid Angiopathy (A)",
    description: "Lobar, cortical or corticosubcortical haemorrhage and age >= 55",
    value: "A",
    interpretation: ""
  },
  {
    name: "Systemic Disease (Liver Cirrhosis, thrombocytopaenia, others) (S)",
    description: "Systemic or other determined cause for ICH, except for anticoagulation, hypertension or amyloid coagulopathy",
    value: "S2",
    interpretation: ""
  },
  {
    name: "Hypertension (H)",
    description: "Deep or infratentorial haemorrhage with pre-ICH hypertension.",
    value: "H",
    interpretation: ""
  },
  {
    name: "Undetermined (U)",
    description: "No aetiology could be determined.",
    value: "U",
    interpretation: "Dementia"
  }
]